module.exports = __webpack_public_path__ + "1ec0ba058c021acf7feaa18081445d63.woff2";